import moment from 'moment';
import scopeUtils from '../../../utils/scope';

export default class AboutController {
    static $inject = ['$scope', '$state', 'cartonomyConfig'];

    constructor(scope, stateService, cartonomyConfig) {
        this._scope = scope;
        this._stateService = stateService;
        this._scope.versionNumber = cartonomyConfig.version;
        this._scope.buildTime = moment(cartonomyConfig.buildTime).utc().format('MM/DD/YYYY HH:mm:ss');
        this.cartonomyConfig = cartonomyConfig;
    }

    async $onInit() {
        let response = await fetch(`${this.cartonomyConfig.ApiV2}/version`);
        this._scope.serverVersion = await response.json();
        scopeUtils.apply(this._scope);
    }
}




// WEBPACK FOOTER //
// ./src/modules/about/controllers/AboutController.js